<section
  class="verse-of-the-day"
  [style.text-align]="config().textAlign"
  [style.backgroundImage]="backgroundImage()"
  [style.backgroundPosition]="backgroundPosition()"
  [style.color]="textColor()"
  [style.textShadow]="textShadow()"
>
  <div class="overlay" [style]="overlayColor()"></div>

  <div class="content">
    <h4 class="title">{{ config().title }}</h4>
    <h3 class="text">“{{ verseOfTheDay()?.text }}”</h3>
    <h4 class="reference">
      — {{ verseOfTheDay()?.reference }} <br />
      <small>{{ config().copyright }}</small>
    </h4>
  </div>
</section>
